export const CHECK_IN_MODAL_TITLE = 'checkIn'

export const CHECK_IN_MODAL_PROPS = { title: CHECK_IN_MODAL_TITLE, backLabelKey: 'checkIn:checkIn' }

export const MANAGE_EQUIPMENTS_TAB_VALUE = '3'

export const OPEN_CHECK_IN_WIDGET_EVENT = 'hapana:open-check-in-widget'
